module.exports = __webpack_public_path__ + "img/119.c0021b9d.png";